import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-required',
  template: '<span *ngIf="show" aria-hidden="true"><app-locale localeKey="REQUIRED" localeView="IFRAME" ></app-locale></span>'
})
export class RequiredComponent implements OnInit {
  @Input() show: boolean = true;
  constructor() { }

  ngOnInit() {
  }

}
